import { gql } from '@apollo/client';

export const INTERVENTION = gql`
  fragment intervention on Intervention {
    id
    name
    beneficiaryCount
    fromDate
    toDate
  }
`;
